<script setup lang="ts">
import type { RouteLocationRaw } from '#vue-router'

export interface SellerLink {
  key: string
  to: RouteLocationRaw | undefined
  active: boolean
  label: string
}

defineProps<{ label: string; links: SellerLink[] }>()
</script>

<template>
  <section class="_col _gap02">
    <h3 v-if="label" class="_pb1 m_pl4 d_pl1">{{ label }}</h3>
    <LinkTablet
      v-for="item in links"
      :key="item.key"
      :to="item.to"
      :active="item.active"
      :txt="ts(item.label)"
    />
  </section>
</template>
